import { DashboardPage } from '~/modules/dashboard/view'

export const DashboardRoutes = () => <DashboardPage />

export const dashboardLinks = {
  dashboardLink: () => '/',
}
